import createIcon from '../../createIcon';

/**
 * @component @name Backspace
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgM0g3QzYuMzEgMyA1Ljc3IDMuMzUgNS40MSAzLjg4TDAgMTJMNS40MSAyMC4xMUM1Ljc3IDIwLjY0IDYuMzEgMjEgNyAyMUgyMkMyMy4xIDIxIDI0IDIwLjEgMjQgMTlWNUMyNCAzLjkgMjMuMSAzIDIyIDNaTTE5IDE1LjU5TDE3LjU5IDE3TDE0IDEzLjQxTDEwLjQxIDE3TDkgMTUuNTlMMTIuNTkgMTJMOSA4LjQxTDEwLjQxIDdMMTQgMTAuNTlMMTcuNTkgN0wxOSA4LjQxTDE1LjQxIDEyTDE5IDE1LjU5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Backspace = createIcon('Backspace', [
  [
    'path',
    {
      d: 'M22 3H7C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.31 21 7 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3ZM19 15.59L17.59 17L14 13.41L10.41 17L9 15.59L12.59 12L9 8.41L10.41 7L14 10.59L17.59 7L19 8.41L15.41 12L19 15.59Z',
      key: '1oh8y7',
    },
  ],
]);

export default Backspace;
